import { Platform, StyleSheet } from "react-native";

export const v2Styles = StyleSheet.create({
  container: { flex: 1, paddingBottom: 24 },
  viewBar: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 12,
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#DCE3EC",
    padding: 14,
    marginBottom: 16,
  },
  label: { fontSize: 13, fontWeight: "700", color: "#5E646D" },
  segmented: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    padding: 3,
    gap: 2,
  },
  segment: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 6,
  },
  activeSegment: { backgroundColor: "#075CB5" },
  segmentText: { fontSize: 13, fontWeight: "600", color: "#495057" },
  activeSegmentText: { color: "#FFFFFF", fontWeight: "700" },
  hint: {
    flex: 1,
    minWidth: 260,
    fontSize: 12,
    lineHeight: 18,
    color: "#808995",
  },
  linkButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    padding: 6,
  },
  linkText: { color: "#075CB5", fontSize: 13, fontWeight: "700" },
  configCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#DCE3EC",
    marginBottom: 16,
    overflow: "hidden",
  },
  configHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    padding: 14,
  },
  configIcon: { color: "#075CB5", fontSize: 18 },
  configTitle: { fontSize: 15, fontWeight: "700", color: "#20242A" },
  badge: {
    backgroundColor: "#075CB5",
    color: "#FFFFFF",
    borderRadius: 20,
    paddingHorizontal: 9,
    paddingVertical: 3,
    fontSize: 11,
    fontWeight: "700",
  },
  configHint: { color: "#737B86", fontSize: 12, flex: 1 },
  chevron: { color: "#737B86", fontSize: 20 },
  configBody: { borderTopWidth: 1, borderTopColor: "#EDF0F4", padding: 16 },
  configDescription: { color: "#68717D", fontSize: 12, marginBottom: 14 },
  slotRow: { flexDirection: "row", flexWrap: "wrap", gap: 12 },
  slot: { width: 190 },
  slotLabelRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 6,
  },
  slotLabel: {
    color: "#68717D",
    fontSize: 11,
    fontWeight: "700",
    textTransform: "uppercase",
  },
  remove: { color: "#B42318", fontSize: 18 },
  select: {
    height: 38,
    borderWidth: 1,
    borderColor: "#CAD3DF",
    borderRadius: 7,
    paddingHorizontal: 8,
    backgroundColor: "#FFFFFF",
    color: "#20242A",
  },
  addColumn: { height: 38, justifyContent: "center", paddingHorizontal: 10 },
  addText: { color: "#075CB5", fontSize: 13, fontWeight: "700" },
  configActions: {
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 10,
    marginTop: 16,
  },
  primaryButton: {
    backgroundColor: "#075CB5",
    borderRadius: 20,
    paddingHorizontal: 18,
    paddingVertical: 8,
  },
  primaryText: { color: "#FFFFFF", fontWeight: "700" },
  secondaryButton: {
    borderWidth: 1,
    borderColor: "#075CB5",
    borderRadius: 20,
    paddingHorizontal: 18,
    paddingVertical: 8,
  },
  secondaryText: { color: "#075CB5", fontWeight: "700" },
  card: {
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#DCE3EC",
    borderRadius: 8,
    marginBottom: 16,
    overflow: "visible",
  },
  tableHead: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    paddingHorizontal: 20,
    paddingTop: 16,
    paddingBottom: 14,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E9EF",
    zIndex: 30,
  },
  tableIntro: { flex: 1, minWidth: 260 },
  title: { fontSize: 17, fontWeight: "700", color: "#20242A" },
  subtitle: { fontSize: 12, color: "#808995", marginTop: 4 },
  toolbar: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 8,
    zIndex: 40,
  },
  search: {
    minWidth: 210,
    height: 34,
    borderWidth: 1,
    borderColor: "#CAD3DF",
    borderRadius: 6,
    paddingHorizontal: 10,
    color: "#20242A",
  },
  tableScroll: { width: "100%", paddingHorizontal: 12 },
  table: {
    width: "100%",
  },
  // tableRow: no width:"100%" — let the horizontal ScrollView size it naturally.
  // Each cell carries its own explicit pixel width so the row is always as wide
  // as the sum of its cells, regardless of the container.
  tableRow: {
    flexDirection: "row",
    alignItems: "center",
    minHeight: 44,
    borderBottomWidth: 1,
    borderBottomColor: "#EDF0F4",
  },
  // Keep legacy `row` alias so any other consumers are unaffected.
  row: {
    flexDirection: "row",
    alignItems: "center",
    minHeight: 44,
    borderBottomWidth: 1,
    borderBottomColor: "#EDF0F4",
  },
  headerRow: { backgroundColor: "#FFFFFF", minHeight: 52, zIndex: 1 },
  totalRow: {
    backgroundColor: "#FFFFFF",
    borderTopWidth: 2,
    borderTopColor: "#D7E5F8",
  },
  // Base cell: layout + typography only.  Width is always supplied by the
  // caller as { width: COL_WIDTHS.grain } or { width: COL_WIDTHS.metric }.
  // No flex, no minWidth — those are what caused the header/body divergence.
  cell: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    fontSize: 12,
    color: "#28313B",
    overflow: "hidden",
  },
  // metricCell: right-aligns numeric columns (matches LoadDetails numColWidth).
  metricCell: {
    textAlign: "right",
  },
  // dimCell kept as a no-op so old references elsewhere don't break.
  dimCell: {},
  headerCell: {
    fontSize: 11,
    lineHeight: 14,
    fontWeight: "700",
    color: "#56606C",
    textAlign: "center",
  },
  headerCellLeft: {
    fontSize: 11,
    lineHeight: 14,
    fontWeight: "700",
    color: "#56606C",
    textAlign: "left",
  },
  valueCell: { textAlign: "center", fontVariant: ["tabular-nums"] },
  // Stretches the cell container to the full row height so the right-side
  // border reaches top-to-bottom even when the row uses alignItems:"center".
  columnDivider: {
    borderLeftWidth: 1,
    borderLeftColor: "#EBEBEB",
    borderStyle: "solid",
    alignSelf: "stretch",
    justifyContent: "center",
  },
  danger: { color: "#C93434", fontWeight: "700" },
  good: { color: "#075CB5", fontWeight: "700" },
  selectedRow: {
    backgroundColor: "#EAF3FF",
    borderLeftWidth: 3,
    borderLeftColor: "#075CB5",
  },
  rowButton: { flex: 1 },
  hierarchyRegion: { backgroundColor: "#FFFFFF" },
  hierarchyMarket: { backgroundColor: "#FFFFFF" },
  hierarchyLocation: { backgroundColor: "#FFFFFF" },
  hierarchyLabel: { fontWeight: "600", color: "#005CBC", fontSize: 12.5 },
  hierarchyMarketLabel: { fontWeight: "600", color: "#005CBC", fontSize: 12.5 },
  hierarchyLocationLabel: { fontWeight: "600", color: "#005CBC", fontSize: 12.5 },
  hierarchyChevron: {
    width: 28,
    paddingHorizontal: 8,
    fontSize: 13,
    color: "#68717D",
    textAlign: "center",
  },
  hierarchyIndent: { paddingLeft: 28 },
  hierarchyMarketIndent: { paddingLeft: 28 },
  footer: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 12,
    backgroundColor: "#FFFFFF",
  },
  footerText: { color: "#68717D", fontSize: 12 },
  pagerCenter: {
    position: "absolute",
    left: 0,
    right: 0,
    alignItems: "center",
    pointerEvents: "box-none",
  } as any,
  pager: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  pagerNavBtn: {
    width: 28,
    height: 28,
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
  },
  pagerNavBtnActive: {
    borderWidth: 1,
    borderColor: "#034895",
  },
  pagerBtnDisabled: { opacity: 0.4 },
  pagerPageLabel: {
    fontSize: 12,
    color: "#6A6D71",
    marginHorizontal: 2,
  },
  pagerPageBox: {
    height: 28,
    minWidth: 32,
    paddingHorizontal: 6,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#005CBC",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
  },
  pagerPageBoxText: {
    fontSize: 12,
    fontWeight: "700",
    color: "#1A1D21",
  },
  pageSizeRow: {
    flexDirection: "row",
    gap: 4,
  },
  pageButton: {
    borderWidth: 1,
    borderColor: "#CAD3DF",
    borderRadius: 5,
    paddingHorizontal: 10,
    paddingVertical: 6,
  },
  pageButtonActive: { backgroundColor: "#075CB5", borderColor: "#075CB5" },
  pageText: { color: "#075CB5", fontSize: 12, fontWeight: "700" },
  pageTextActive: { color: "#FFFFFF" },
  columnMenu: {
    position: "absolute",
    left: 0,
    top: 40,
    zIndex: 200,
    width: 240,
    maxHeight: 320,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#D0D0D0",
    borderRadius: 8,
    paddingVertical: 6,
    shadowColor: "#3A3A3A",
    shadowOpacity: 0.12,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 4 },
    elevation: 6,
    ...Platform.select({
      web: { boxShadow: "0 4px 24px rgba(58,58,58,.08)" } as any,
      default: {},
    }),
  },
  columnMenuScroll: {
    maxHeight: 320,
  },
  menuSection: {
    borderTopWidth: 1,
    borderTopColor: "#EDF0F4",
    marginTop: 4,
    paddingTop: 4,
  },
  menuSectionTitle: {
    paddingHorizontal: 14,
    paddingTop: 8,
    paddingBottom: 4,
    fontSize: 11,
    fontWeight: "700",
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: "#5E646D",
  },
  menuItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    paddingHorizontal: 14,
    paddingVertical: 8,
  },
  checkbox: {
    width: 16,
    fontSize: 18,
    lineHeight: 18,
    color: "#075CB5",
    fontWeight: "700",
  },
  menuText: { color: "#2D2D2D", fontSize: 13 },
  companionHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    padding: 14,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E9EF",
  },
  companionIcon: { fontSize: 20, color: "#075CB5" },
  companionTitle: {
    flex: 1,
    fontWeight: "700",
    fontSize: 15,
    color: "#20242A",
  },
  companionSub: { fontSize: 12, color: "#808995", marginTop: 3 },
  empty: { padding: 24, color: "#808995", fontSize: 13 },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    paddingHorizontal: 12,
    paddingVertical: 12,
    backgroundColor: "#FFFFFF",
    borderBottomWidth: 1,
    borderBottomColor: "#EDF0F4",
    shadowColor: '#A8B4C5',
    shadowOpacity: 0.08,
    shadowRadius: 4,
    shadowOffset: { width: 0, height: 2 },
    elevation: 2,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E3E9F3',
  },
  headerTitleSection: {
    paddingHorizontal: 0,
    paddingVertical: 12,
    marginBottom: 12,
  },
  headerTitle: {
    fontSize: 17,
    fontWeight: "700",
    color: "#20242A",
  },
  headerSubtitle: {
    fontSize: 12,
    color: "#808995",
    marginTop: 3,
    lineHeight: 18,
  },
  headerActionsBar: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 10,
  },
  relativePositioning: {
    position: "relative",
  },
  columnMenuButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    height: 36,
    paddingHorizontal: 14,
    borderWidth: 1,
    borderColor: "#005CBC",
    borderRadius: 24,
    backgroundColor: "#FFFFFF",
  },
  columnMenuButtonMobile: {
    paddingHorizontal: 10,
    gap: 4,
  },
  exportButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    height: 36,
    paddingHorizontal: 14,
    borderWidth: 1,
    borderColor: "#005CBC",
    borderRadius: 24,
    backgroundColor: "#FFFFFF",
  },
  exportButtonMobile: {
    paddingHorizontal: 10,
    gap: 4,
  },
  exportButtonDisabled: {
    opacity: 0.55,
  },
  exportButtonText: {
    fontSize: 13,
    fontWeight: "700",
    color: "#005CBC",
  },
  // ── Toolbar controls — matches LoadDetails styling exactly ───────────────
  searchContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    height: 36,
    paddingHorizontal: 10,
    borderWidth: 1,
    borderColor: "#D0D0D0",
    borderRadius: 6,
    backgroundColor: "#FFFFFF",
  },
  searchContainerMobile: {
    flex: 1,
    minWidth: 120,
  },
  searchContainerFocused: {
    borderColor: "#005CBC",
  },
  searchInput: {
    width: 220,
    fontSize: 13,
    color: "#1A1D21",
    outline: "none",
  } as any,
  searchInputMobile: {
    width: undefined,
    flex: 1,
    minWidth: 0,
  },
  menuButton: {
    fontSize: 13,
    fontWeight: "700",
    color: "#005CBC",
    textAlign: "center",
  },
  // First section has no top border; subsequent sections get a divider.
  columnSection: {
    paddingVertical: 4,
  },
  columnSectionDivider: {
    borderTopWidth: 1,
    borderTopColor: "#EDF0F4",
    marginTop: 2,
  },
  columnSectionTitle: {
    paddingHorizontal: 14,
    paddingTop: 8,
    paddingBottom: 2,
    fontSize: 11,
    fontWeight: "700",
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: "#5E646D",
  },
  columnOption: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 14,
    paddingVertical: 6,
    gap: 8,
  },
  columnOptionText: {
    fontSize: 13,
    color: "#1A1D21",
    flexShrink: 1,
  },
  tableWrapper: {
    flex: 1,
    width: "100%",
    zIndex: -9,
  },
  headerText: {
    fontSize: 12,
    lineHeight: 14,
    fontWeight: "700",
    color: "#56606C",
    textAlign: "center",
    textTransform: "uppercase",
  },
  // ── Empty state ───────────────────────────────────────────────────────────
  emptyStateContainer: {
    flex: 1,
    minHeight: 200,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 24,
    paddingVertical: 60,
  },
  emptyStateText: {
    fontSize: 13,
    color: "#6B6E72",
    textAlign: "center",
  },
});
